import React, {useState, useRef} from 'react';
import {Overlay} from 'react-bootstrap';
import CogWheelIcon from '../../../assests/img/cog-wheel.svg?react';
import {NavLink, useLocation} from 'react-router-dom';
import {getTopBarSettingItems} from '../functions/getTopBarNavItems';
import Logs from './Logs';

interface adminSettingProps {
    isAdmin: boolean,
}

function AdminSetting(props: adminSettingProps) {
    const {isAdmin} = props;
    const currentLocation = useLocation();
    const [
        showMenu,
        setShowMenu,
    ] = useState<boolean>(false);
    const targetRef = useRef(null);

    const handleShowMenu = (value: boolean) => {
        setShowMenu(value);
    };

    const getNavItems = () => {
        if (isAdmin) {
            return getTopBarSettingItems(currentLocation.pathname);
        } else {
            return getTopBarSettingItems(currentLocation.pathname)
            .filter((navItem) => {
                return !navItem.isAdmin;
            });
        }
    };

    const renderContent = () => {
        const topBarNavItems = getNavItems();
        return (
            <div className='manage-user-menu p-0'>
                {topBarNavItems.map((navItem, index) => {
                        return (
                            navItem.type === 'navLink' ?
                            <NavLink
                                to={`${navItem.url}`}
                                className={navItem.className}
                                end={index===0}
                                key={`${navItem.type}-${navItem.url}`}
                                >
                                {navItem.label}
                            </NavLink> :
                            <Logs
                                key={`${navItem.type}-${navItem.url}`}
                                btnCustomClassName={navItem.className}
                            />
                        );
                    })}
            </div>
        );
    }
    return (
        <>
            <div
                ref={targetRef}
                onClick={() => handleShowMenu(!showMenu)} className='manage-user-menu-trigger w-auto'
            >
                    <CogWheelIcon width={18} height={18}/>
            </div>
            <Overlay
                target={targetRef.current}
                show={showMenu}
                rootClose={true}
                placement='bottom'
                rootCloseEvent='mousedown'
                onHide={() => handleShowMenu(false)}
            >
                {({
                    placement: _placement,
                    arrowProps: _arrowProps,
                    show: _show,
                    popper: _popper,
                    hasDoneInitialMeasure: _hasDoneInitialMeasure,
                    ...props
                }) => (
                    <div {...props}>
                        {renderContent()}
                    </div>
                )}
            </Overlay>
        </>
    );
}

export default AdminSetting;
